module.exports = __webpack_public_path__ + "img/road-2371503_1920.06e541c4.jpg";